/* ============================================
   Theme - Brand colours, fonts, shared values
   ============================================ */

export const GOLD = "#c9a227";
export const DARK_GOLD = "#8b6914";
export const BG_DARK = "#07090d";
export const BG_CARD = "#0c0f16";
export const TEXT_PRIMARY = "#fff";
export const TEXT_BODY = "#c8d6e5";
export const TEXT_MUTED = "#8a9ab5";
export const TEXT_DIM = "#5a6b80";
export const TEXT_SUBTLE = "#6b7c93";
export const BORDER = "#ffffff08";
export const FONT_HEADING = "Syne, sans-serif";
export const FONT_BODY = "DM Sans, sans-serif";
